import React from 'react'
import { useNavigate } from 'react-router'

export default function Logo({ navFunc }) {
    const navigate = useNavigate()
    return <img className='mainLogo' style={{ cursor: "pointer" }} onClick={() => navFunc ? navFunc("/home") : navigate('/home')
    } src={require("../Media/Logo.png")} alt="SG Poll Logo" />
}
